import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";

const Buildings = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [cookies] = useCookies();
  const token = cookies.token;

  useEffect(() => {
    const headers = new Headers({ 'Valid-token': token });
    fetch('https://services.solucore.com/solutrak/api/buildings/getBuildingInfos', { method: 'GET', headers })
      .then((response) => response.json())
      .then((result) => { setData(result.Data); })
      .catch((error) => { console.error('API Error:', error); });
  }, []);

  return (
    <div className="bg-[#0F172A] p-6 overflow-y-auto h-full w-full flex flex-col">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-white">Buildings</h1>
            <p className="text-sm text-slate-400 mt-1">Manage your buildings and their configurations</p>
          </div>
          <span className="text-3xl">🏢</span>
        </div>

        <div className="bg-slate-800/60 border border-slate-700/50 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-700/50">
                  <th className="text-left py-3 px-5 text-xs font-semibold text-slate-400 uppercase tracking-wider">Building Name</th>
                  <th className="text-left py-3 px-5 text-xs font-semibold text-slate-400 uppercase tracking-wider">Location</th>
                  <th className="text-center py-3 px-5 text-xs font-semibold text-slate-400 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data && data.length > 0 ? (
                  data.map((building) => (
                    <tr key={building.id} className="border-b border-slate-700/30 hover:bg-slate-700/20 transition">
                      <td className="py-3 px-5 text-white font-medium">{building.buildingName}</td>
                      <td className="py-3 px-5 text-slate-300">{building.city}</td>
                      <td className="py-3 px-5 text-center">
                        <button
                          onClick={() => {
                            if (building.buildingId) {
                              navigate(`/Buildings/${building.buildingId}/Banks`, { state: { bankInfos: building.bankInfos, buildingName: building.buildingName } });
                            }
                          }}
                          className="px-3 py-1 bg-cyan-600 hover:bg-cyan-500 text-white text-xs font-semibold rounded-lg transition"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="py-8 text-center text-slate-500">No buildings found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buildings;
